/* eslint-disable react/prop-types */
import React, { useMemo, useState } from 'react'
import { LinearProgress, styled } from '@mui/material'
import { DataGrid, GridRow, GridColumnHeaders, ptBR } from '@mui/x-data-grid'
import { useQualityNumberFilters } from 'hooks/useQualityNumberFilters'
import { CustomGridPagination, CustomNoRowsOverlay } from './Customized'

const MemoizedRow = React.memo(GridRow)
const MemoizedColumnHeaders = React.memo(GridColumnHeaders)

const CustomDataGrid = styled(DataGrid)({
  border: 'none',
  '.grid-list-virtual-scroller': {
    minHeight: 'fit-content',
  },
  '&.grid-list-root .grid-list-cell:focus-within': {
    outline: 'none !important',
  },
  '.grid-list-columnHeader:focus-within': {
    outline: 'none',
  },
  '.grid-list-columnHeader': {
    cursor: 'pointer',
  },
  '.grid-list-columnHeaders': {
    width: '100%',
  },
  '.grid-list-columnHeaderTitleContainerContent': {
    width: '100%',
    fontWeight: 'bold',
    wrapSpace: 'normal',
  },
  '.HiTheme-DataGrid-overlayWrapperInner, .HiTheme-DataGrid-overlayWrapper': {
    height: '473px',
  },
})

function Grid({ rows, columns, loading, rowCount, pageSizeOptions, isPreviousData, slotProps, ...restDataGridProps }) {
  const [sortModel, setSortModel] = useState([{ field: 'isActive', sort: 'desc' }])

  const {
    filters: { page, pageSize },
    setPage,
  } = useQualityNumberFilters()

  const handleModelChange = (model) => {
    setSortModel(model)
  }

  const handlePaginationModelChange = (model) => {
    if (isPreviousData) return
    setPage({ page: model.page + 1, pageSize: model.pageSize })
  }

  const dataGrid = useMemo(() => {
    return {
      editable: false,
      columns,
      rows,
    }
  }, [rows, columns])

  return (
    <CustomDataGrid
      {...dataGrid}
      paginationModel={{
        page: parseInt(page, 10) - 1,
        pageSize: parseInt(pageSize, 10),
      }}
      data-testid="data-grid-monitoring-numbers"
      sortingOrder={['asc', 'desc']}
      sortModel={sortModel}
      onSortModelChange={handleModelChange}
      onPaginationModelChange={handlePaginationModelChange}
      rowCount={rowCount}
      loading={loading}
      pageSizeOptions={pageSizeOptions}
      paginationMode="server"
      rowHeight={64}
      hideFooterSelectedRowCount
      disableRowSelectionOnClick
      disableColumnMenu
      classes={{
        root: 'grid-list-root',
        cell: 'grid-list-cell',
        columnHeader: 'grid-list-columnHeader',
        columnHeaderTitleContainer: 'grid-list-columnHeaderTitleContainerContent',
        columnHeaders: 'grid-list-columnHeaders',
        virtualScroller: 'grid-list-virtual-scroller',
      }}
      slots={{
        noRowsOverlay: CustomNoRowsOverlay,
        row: MemoizedRow,
        columnHeaders: MemoizedColumnHeaders,
        pagination: CustomGridPagination,
        loadingOverlay: LinearProgress,
      }}
      slotProps={slotProps}
      localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
      {...restDataGridProps}
    />
  )
}

export default Grid
